const app = () => {
  // console.log('start js');
};

export { app };
